/**
 * accountStatusTarget.ts — кому отдать WS-событие TELEGRAM_ACCOUNT_STATUS (DEV-2144).
 *
 * Бэкенд шлёт его владельцу аккаунта и всем admin/hos (DEV-2143), поэтому в одно
 * соединение приходят статусы чужих аккаунтов. Без разбора по login_id отзыв
 * support-сессии выглядел бы у админа как отвал его собственного Telegram.
 */
import { SUPPORT_LOGIN_ID } from '@/features/messenger/stores/telegramSession'

export type AccountStatusTarget = 'own' | 'support' | 'ignore'

export function accountStatusTarget(
  loginId: string | undefined,
  myId: string | undefined,
): AccountStatusTarget {
  // Старый бэкенд без login_id слал только владельцу — считаем своим.
  if (!loginId) return 'own'
  if (loginId === SUPPORT_LOGIN_ID) return 'support'
  return loginId === myId ? 'own' : 'ignore'
}
